import React from "react";
import { LibraryEntity, TabType } from "../types";
import ContentCard from "./ContentCard";

const eventIcon = require("../../PhotoManager/styles/images/Event.svg");

interface ContentResultsProps {
  entities: LibraryEntity[];
  query: string;
  activeTab: TabType;
  isSingleCategory: boolean;
  handleEntityClick: (entity: LibraryEntity) => void;
  highlightSearchTerm: (text: string, searchTerm: string) => React.ReactNode;
  setActiveTab: (tab: TabType) => void;
}

const ContentResults: React.FC<ContentResultsProps> = ({
  entities,
  query,
  activeTab,
  isSingleCategory,
  handleEntityClick,
  highlightSearchTerm,
  setActiveTab
}) => {
  if (entities.length === 0) return null;

  const shouldLimit = activeTab === "all" && !isSingleCategory;
  const displayEntities = shouldLimit ? entities.slice(0, 5) : entities;
  const showSeeAll = shouldLimit && entities.length > 5;

  return (
    <div className="unified-search-section enhanced-search-results">
      <h2 className="unified-search-section-title">
        <img
          src={eventIcon}
          alt="Content"
          className="unified-search-section-icon"
        />
        Content
      </h2>
      <div className="unified-search-content-list">
        {displayEntities.map(entity => (
          <ContentCard
            key={`${entity.type}-${entity.id}`}
            entity={entity}
            query={query}
            onClick={handleEntityClick}
            highlightSearchTerm={highlightSearchTerm}
            showTypeLabel={false}
          />
        ))}
      </div>
      {showSeeAll && (
        <button
          className="unified-search-see-all enhanced-search-see-all-btn"
          onClick={() => setActiveTab("content")}
        >
          See all
        </button>
      )}
    </div>
  );
};

export default ContentResults;
